import {InjectionToken} from '@angular/core'

export const LOCAL_STORAGE = new InjectionToken<Storage>('localStorage')

export const excludedOffices = [
  'Administration',
  'Bankledning',
  'Behörigheter',
  'Ekonomi',
  'Förvaltning',
  'HAK',
  'HR',
  'Kredit',
  'Kundstöd',
  'Produkt, Process & IT',
  'Riskenhet',
  'SDC',
  'Spara och Försäkra',
  'Sparbanken Syd',
  'Säkerhet Internservice',
  'Telefonbanken'
]

export const USER_DOC_ROLE_NAME = 'userDocUser'
export const REGISTRAR_ROLE_NAME = 'loanPromiseRegistrar'
export const READ_ONLY_ROLE = 'loanPromiseReadOnly'
export const ADMIN_ROLE = 'admin'
